import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import img from 'assets/img/spinner.png';

var Spinner = /*#__PURE__*/function (_Component) {
  _inherits(Spinner, _Component);

  var _super = _createSuper(Spinner);

  function Spinner(props) {
    var _this;

    _classCallCheck(this, Spinner);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getContainerClassName", function () {
      var _this$props = _this.props,
          center = _this$props.center,
          right = _this$props.right,
          small = _this$props.small;
      var classNames = 'spinner-container';

      if (center) {
        classNames += ' center';
      }

      if (right) {
        classNames += ' right';
      }

      if (small) {
        classNames += ' small';
      }

      return classNames;
    });

    return _this;
  }

  _createClass(Spinner, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: this.getContainerClassName(),
        key: "spinner"
      }, /*#__PURE__*/React.createElement("div", {
        className: "loading-spinner",
        style: {
          backgroundImage: "url(".concat(img, ")")
        }
      }));
    }
  }]);

  return Spinner;
}(Component);

export default Spinner;